// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
   production: false,
      firebaseConfig :{
   apiKey: "AIzaSyBtQZccV8pmQn370QLdNV8AI7-K9EeN8Ls",
  authDomain: "foryt-946bf.firebaseapp.com",
  databaseURL: "https://foryt-946bf-default-rtdb.firebaseio.com",
  projectId: "foryt-946bf",
  storageBucket: "foryt-946bf.firebasestorage.app",
  messagingSenderId: "130981156170",
  appId: "1:130981156170:web:af83de920177829cac1db3",
  measurementId: "G-MN3J75EYDL"
}

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
